<script>
import find from 'lodash/find';
import {mapState} from 'vuex';

import leftImg from 'assets/images/responsive/home-category-left.jpg?min=320&max=1260';
import rightImg from 'assets/images/responsive/home-category-right.jpg?min=320&max=1260';
import ResponsiveImage from '@/components/ResponsiveImage';

export default {
  components: {
    ResponsiveImage,
  },
  data: () => ({
    leftImg,
    rightImg,
  }),
  computed: {
    ...mapState({
      categories: state => state.marketplace.categories,
    }),
  },
};
</script>

<template lang='pug'>
.mt-2.container.mx-auto.lg_mt-3.xl_mt-4
  .text-brand-secondary-900.font-bold.mx-2_25.md_mx-1.text-4xl.md_text-3xl We curate, you shop
  .flex.flex-wrap
    .w-full.md_w-1-2.mt-1_5
      .md_ml-1.md_mr-_5
        router-link.home-curated-img.block.transition.transition-250(:to='{ name: "collection", params: { publicName: "market", collectionSlug: "trending", page: "1" } }')
          responsive-image(
            sizes='(min-width: 768px) 50%, 100vw',
            :image-object='leftImg',
            alt-text='Face Coverings',
          )
    .w-full.md_w-1-2.mt-1_5
      .md_mr-1.md_ml-_5
        router-link.home-curated-img.block.transition.transition-250(:to='{ name: "collection", params: { publicName: "market", collectionSlug: "holidays", page: "1" } }')
          responsive-image(
            sizes='(min-width: 768px) 50%, 100vw',
            :image-object='rightImg',
            alt-text='Trending Products',
          )
</template>

<style>
@import '~import/index';

.home-curated-img {
  &:hover,
  &:active {
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
  }
}
</style>